"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ConverterSwitchIcon = function ConverterSwitchIcon() {
  return _react["default"].createElement("svg", {
    width: "50px",
    height: "47px",
    viewBox: "0 0 50 47",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Inverse button",
    role: "img"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-297.000000, -595.000000)",
    fill: "#FFFFFF"
  }, _react["default"].createElement("g", {
    transform: "translate(50.000000, 394.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(247.000000, 201.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(7.142857, 25.000000)"
  }, _react["default"].createElement("polygon", {
    points: "42.7539856 10.9773747 19.455409 0 19.455409 7.87415338 0 7.87415338 0 14.080596 19.455409 14.080596 19.455409 21.9547493"
  })), _react["default"].createElement("g", {
    transform: "translate(21.428571, 11.309524) rotate(-180.000000) translate(-21.428571, -11.309524) "
  }, _react["default"].createElement("polygon", {
    points: "42.7539856 10.9773747 19.455409 0 19.455409 7.87415338 0 7.87415338 0 14.080596 19.455409 14.080596 19.455409 21.9547493"
  })))))));
};

var _default = ConverterSwitchIcon;
exports["default"] = _default;